import '/assets/css/tabs.css';

export class TabManager {

    headingsDiv: HTMLDivElement;
    bodiesDiv: HTMLDivElement;

    tabheadingRightDiv: HTMLDivElement;

    tabs: Tab[] = [];


    constructor(private container: HTMLElement, public sharedBody: boolean = false) {
        this.container.classList.add('jo_tabs_container');

        this.headingsDiv = document.createElement('div');
        this.headingsDiv.classList.add('jo_tabheadings')
        this.container.appendChild(this.headingsDiv);

        this.bodiesDiv = document.createElement('div');
        this.bodiesDiv.classList.add('jo_tabs')
        this.container.appendChild(this.bodiesDiv);

        this.tabheadingRightDiv = document.createElement('div');
        this.tabheadingRightDiv.classList.add("jo_tabheading-right", "jo_noHeading");
        this.headingsDiv.appendChild(this.tabheadingRightDiv);

    }

    addTab(tab: Tab) {
        tab.tabManager = this;
        this.tabs.push(tab);
        this.headingsDiv.insertBefore(tab.headingDiv, this.tabheadingRightDiv);
        if (!this.sharedBody) {
            this.bodiesDiv.appendChild(tab.bodyDiv);
        }
    }

    insertIntoRightDiv(element: HTMLElement) {
        this.tabheadingRightDiv.appendChild(element);
    }

    insertIntoHeadingDiv(element: HTMLElement) {
        this.headingsDiv.insertBefore(element, this.tabheadingRightDiv);
    }

    setActive(tab: Tab) {

        for (let tab1 of this.tabs) {
            if (tab1 == tab) continue;
            if (tab1.headingDiv.classList.contains('jo_active')) {
                if (tab1.onHide) tab1.onHide();
            }
            tab1.headingDiv.classList.remove('jo_active');
            if (!this.sharedBody) tab1.bodyDiv.style.display = 'none';
        }

        tab.headingDiv.classList.add('jo_active');
        if (!this.sharedBody) tab.bodyDiv.style.display = 'flex'
        if (tab.onShow) tab.onShow();

    }

    setTabVisible(tab: Tab, visibility: boolean) {
        if(tab.visible == visibility) return;
        
        tab.headingDiv.style.display = visibility ? 'block' : 'none';
        tab.bodyDiv.style.display = visibility ? '' : 'none';
        tab.visible = visibility;
        if (!visibility && tab.isActive()) {
            let firstVisibleTab = this.tabs.find(t => t.visible);
            if (firstVisibleTab) this.setActive(firstVisibleTab);
        }
    }

    getTabByName(name: string) {
        return this.tabs.find(t => t.name == name);
    }

}

export class Tab {
    headingDiv: HTMLDivElement;
    bodyDiv: HTMLDivElement;
    tabManager: TabManager;

    visible: boolean = true;

    onShow: () => void;
    onHide: () => void;

    constructor(public name: string, caption: string, cssClasses: string[] = [], withoutBody: boolean = false) {
        this.headingDiv = document.createElement('div');
        this.headingDiv.classList.add('jo_tabheading');
        this.headingDiv.textContent = caption;

        this.headingDiv.onclick = (ev: MouseEvent) => {
            this.show();
        }

        if (!withoutBody) {
            this.bodyDiv = document.createElement('div');
            this.bodyDiv.classList.add('jo_tab');
            for (let cssClass of cssClasses) this.bodyDiv.classList.add(cssClass);
        }

    }

    show() {
        this.tabManager.setActive(this);
    }

    isActive(): boolean {
        return this.headingDiv.classList.contains('jo_active');
    }

    setVisible(visibility: boolean) {
        this.tabManager.setTabVisible(this, visibility);
    }


}